import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";

function Thanksgiving() {
  return (
    <>
      <Navbar2 />
      <div>
        <a href="https://maps.app.goo.gl/i95nUpSRspzPGZqo8"
          target="_blank" rel="noreferrer">
          <img src="/s3/thanksgiving2.jpg"
            alt=""
            className="img-fluid"
          />
        </a>
      </div>
      <div className="container-fluid">
        <div className="row p-5">
          <div className="col-6 text-end d-none d-md-block">
            <div className="">
              <img src="/s3/thanksgiving3.png"
            alt=""
            className="img-fluid w-75"
          />
            </div>
          </div>
          <div className="col-6">
            <p className="lead">ADS Sports invites our community to a &nbsp;
              <span className="fw-bold">Free Food Box Giveaway</span> on &nbsp;
              <span className="fw-bold">November 22, 2025</span>, from
              <span className="fw-bold"> 9:00 AM to 12:00 PM </span>at the &nbsp;
              <a href="https://maps.app.goo.gl/i95nUpSRspzPGZqo8"
                target="_blank" rel="noreferrer"><br/>
                ADS Sports Complex in Converse, TX.
              </a>
            </p>
            <p>We know the holiday season can be challenging for many families —
            especially when school is out and grocery costs rise.
            That&apos;s why we&apos;re coming together to help bridge the gap with family food boxes,
            available first come, first served while supplies last.
            </p>
            <p>Beyond the food, this is about connection — meeting our neighbors,
            sharing resources, and showing that our strength as a community lies in how we show up for one another.
            </p>
            <p>Stop by to meet the ADS Sports team, learn more about our wellness complex, and connect with ADS Staff.
            With Absolute Determination & Sacrifice, we&apos;re proud to stand beside our community — both on and off the court.
            </p>
            <p>
              Food generously provided by ADS Sports and the Timothy Porter Foundation
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
);
}

export default Thanksgiving;
